import { useContext } from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import Image from 'next/image';

import styles from './offers-nav.module.scss';

import { NavContext } from 'Context/nav-context';
import { assetsPath } from 'Data/constants';
import { formatLink } from '@/utils';
import { useDetermineBanner, useDetermineEnvironment } from '@/hooks';

const svg: any = {
  FrontShopOffersSaleNavNode: `${assetsPath}/site-icons/offers-save.svg`,
  FrontShopOffersClearanceNavNode: `${assetsPath}/site-icons/offers-clearance.svg`,
  FrontShopOffersGWPBeautyNavNode: `${assetsPath}/site-icons/offers-gift.svg`,
  FrontShopOffersPCOptimumOffersNavNode: `${assetsPath}/site-icons/offers-optimum.svg`,
};
export const checkTargetforClasses = (target: String, setL0: any) => {
  if (target?.includes('mega') || target?.includes('L1') || target?.includes('L2') || target?.includes('navHeader'))
    setL0('');
};
const OffersNav = ({ navigation }: { navigation: any }) => {
  const {
    category: {
      ['uid']: [uid],
      ['L0']: [L0, setL0],
    },
  } = useContext(NavContext);
  const isPhxBanner = useDetermineBanner();
  const env = useDetermineEnvironment();
  const navL0 = navigation?.filter((x: any) => x.uid === uid)[0]?.child?.filter((y: any) => y.uid === L0)[0];
  const navL1 = navL0?.child;
  const showNav =
    L0 === '' || L0 !== 'FrontShopOffersNavNode' || !navL0?.hasChildren ? { display: 'none' } : { display: 'block' };
  return (
    <nav
      className={styles.offersNavContainer}
      style={showNav}
      onMouseLeave={(e: any) => {
        const target = e.target?.parentNode?.parentNode?.className;
        checkTargetforClasses(target, setL0);
      }}
      data-testid="nav-in-offer-nav"
    >
      <div className={styles.navHeaderLayout}>
        <div className={styles.L1Container}>
          <ul className={styles.navItemsLayout}>
            {navL1?.map(
              ({
                name,
                uid,
                link,
                width,
                height,
              }: {
                name: string;
                uid: any;
                link: string;
                width: number;
                height: number;
              }) => {
                return (
                  <li key={uid}>
                    <Link href={formatLink(link, isPhxBanner, env)}>
                      <span className={styles.svg}>
                        <Image
                          src={svg[uid]}
                          alt={name}
                          aria-label={name}
                          width={width ?? 150}
                          height={height ?? 150}
                        />
                      </span>
                      <span>{name}</span>
                    </Link>
                  </li>
                );
              }
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

OffersNav.propTypes = {
  navigation: PropTypes.array,
  category: PropTypes.object,
};

export default OffersNav;
